__turbopack_context__.v({
  "bottom-left-chair": "styles-module-scss-module__Vt5yiG__bottom-left-chair",
  "bottom-right-chair": "styles-module-scss-module__Vt5yiG__bottom-right-chair",
  "bottom-row": "styles-module-scss-module__Vt5yiG__bottom-row",
  "container": "styles-module-scss-module__Vt5yiG__container",
  "top-left-chair": "styles-module-scss-module__Vt5yiG__top-left-chair",
  "top-middle-chair": "styles-module-scss-module__Vt5yiG__top-middle-chair",
  "top-right-chair": "styles-module-scss-module__Vt5yiG__top-right-chair",
  "top-row": "styles-module-scss-module__Vt5yiG__top-row",
});
